import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { VIDEO_EVENTS } from 'playable/dist/src/constants';
import { get } from 'lodash';
export class ErrorLogger extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "logError", error => {
      const {
        videoID,
        engine,
        logFunction,
        isLive
      } = this.props;
      const videoUrl = get(engine, 'attachedAdapter.currentUrl', null);
      const {
        errorType,
        streamProvider,
        streamType
      } = error;
      logFunction({
        videoID,
        videoUrl,
        errorType,
        streamProvider,
        streamType,
        isLive
      });
    });
    this.subscribeToEvents();
  }
  componentWillUnmount() {
    this.unSubscribeFromEvents();
  }
  subscribeToEvents() {
    const {
      eventEmitter
    } = this.props;
    eventEmitter.on(VIDEO_EVENTS.ERROR, this.logError);
  }
  unSubscribeFromEvents() {
    const {
      eventEmitter
    } = this.props;
    eventEmitter.off(VIDEO_EVENTS.ERROR, this.logError);
  }
  render() {
    return null;
  }
}
//# sourceMappingURL=error-logger.js.map